module.exports = __webpack_public_path__ + "static/media/ad-demo.40dac9aa.ogg";